import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';



const About = () => {

  const { sub, heading, title, description, image, button } = about;

  return (
    <section className="about">

      {/* Section Heading */}
      <Heading title={heading} subTitle={sub} />

      <div className='box-container'>

        {/* About Image */}
        <div className="image">
          <img src={image.src} alt={image.alt} />
        </div>

        {/* Introduction Content */}
        <div className="content">

          <h3>{title}</h3>

          <div className="line"></div>

          {/* Description */}
          {description.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}

          {/* Button Component: Links to a specific page or action */}
          <Button link={button.link} title={button.text} />

        </div>

      </div>

    </section>
  );
};

export default About;